<template>
  <div class="car-container" ref="carContainer">
    <template v-for="item in roadList" v-bind:key="item">
      <div
        class="road-tag"
        :id="'road-' + item.id"
        :ref="'road-' + item.id"
        :style="{
          left: item.l + 'px',
          top: item.t + 'px',
          transform: 'rotate(' + item.rotate + 'deg)',
          width: item.w + 'px',
        }"
      >
        <template v-for="(item_, j) in prevVehicle" v-bind:key="j">
          <!--div
            v-if="item_.deviceNo && item_.roadModelId == item.id"
            :ref="'car-' + item_.deviceNo"
            class="car-tag"
            :style="{
              marginTop:
                (item.road_type == 'parkingLot'
                  ? Math.floor(30 * Math.random()) - 20
                  : -5) + 'px',
              zIndex: j + 1,
            }"
          ></div-->
          <div
            v-if="
              item_.deviceNo &&
              (item_.roadModelId == item.id || item_.roadModelId == item.subId)
            "
            :ref="'car-' + item_.deviceNo"
            :id="'car-' + item_.deviceNo"
            class="car-tag"
            :style="{
              marginTop: -5 + 'px',
              zIndex: j + 1,
            }"
          ></div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    //这里存放数据
    return {
      customerId: this.$store.state.customerId,
      roadList: [
        {
          id: "42_8",
          t: 75,
          l: 90,
          w: 155,
          rotate: 1.3,
        },
        {
          id: "42_7",
          t: 78,
          l: 247,
          w: 248,
          rotate: 1.3,
        },
        {
          id: "42_6",
          t: 83,
          l: 498,
          w: 160,
          rotate: 1.3,
          prev: ["42_7"],
          mid: ["42_14"],
          next: ["42_54"],
        },
        {
          id: "42_14",
          t: 85,
          l: 619,
          w: 87,
          rotate: 88,
        },
        {
          id: "42_13",
          t: 173,
          l: 624,
          w: 275,
          rotate: 89,
        },
        {
          id: "42_12",
          t: 448,
          l: 629,
          w: 109,
          rotate: 88.5,
        },
        {
          id: "42_44",
          t: 558,
          l: 631,
          w: 81,
          rotate: 77,
        },
        {
          id: "42_43",
          t: 642,
          l: 650,
          w: 198,
          rotate: 87,
        },
        {
          id: "42_25",
          t: 91,
          l: 252,
          w: 92,
          rotate: 90,
        },
        {
          id: "42_24",
          t: 186,
          l: 252,
          w: 223,
          rotate: 90,
        },
        {
          id: "42_23",
          t: 411,
          l: 252,
          w: 96,
          rotate: 89.7,
        },
        {
          id: "42_22",
          t: 508,
          l: 252,
          w: 121,
          rotate: 89.7,
        },
        {
          id: "42_21",
          t: 632,
          l: 253,
          w: 71,
          rotate: 89.5,
        },
        {
          id: "42_47",
          t: 584,
          l: 507,
          w: 72,
          rotate: 92,
        },
        {
          id: "42_46",
          t: 657,
          l: 505,
          w: 48,
          rotate: 92,
        },
        {
          id: "42_45",
          t: 706,
          l: 505,
          w: 136,
          rotate: 92,
        },
        {
          id: "42_18",
          t: 178,
          l: 396,
          w: 226,
          rotate: 87,
        },
        {
          id: "42_29",
          t: 400,
          l: 477,
          w: 189,
          rotate: 86.2,
        },
        {
          id: "42_65",
          t: 636,
          l: 576,
          w: 67,
          rotate: 88.4,
        },
        {
          id: "42_64",
          t: 704,
          l: 578,
          w: 137,
          rotate: 88.2,
        },
        {
          id: "42_19",
          t: 323,
          l: 307,
          w: 90,
          rotate: 88,
        },
        {
          id: "42_34",
          t: 192,
          l: 92,
          w: 319,
          rotate: 90.3,
        },
        {
          id: "42_33",
          t: 512,
          l: 92,
          w: 272,
          rotate: 89.9,
        },
        {
          id: "42_48",
          t: 784,
          l: 92,
          w: 66,
          rotate: 88.8,
        },
        {
          id: "42_11",
          t: 188,
          l: 82,
          w: 167,
          rotate: -2,
        },
        {
          id: "42_11",
          t: 188,
          l: 82,
          w: 167,
          rotate: -2,
        },
        {
          id: "42_10",
          t: 182,
          l: 251,
          w: 144,
          rotate: -2,
        },
        {
          id: "42_9",
          t: 177,
          l: 396,
          w: 265,
          rotate: -2.3,
        },
        {
          id: "42_20",
          t: 322,
          l: 250,
          w: 57,
          rotate: -4.3,
        },
        {
          id: "42_16",
          t: 404,
          l: 242,
          w: 165,
          rotate: -2,
        },
        {
          id: "42_15_1",
          subId: "42_15",
          rate: 68 / (68 + 84),
          t: 398,
          l: 405,
          w: 68,
          rotate: -2,
        },
        {
          id: "42_15_2",
          subId: "42_15",
          rate: 84 / (68 + 84),
          t: 396,
          l: 470,
          w: 84,
          rotate: -2,
        },
        {
          id: "42_27",
          t: 503,
          l: 86,
          w: 166,
          rotate: 0.8,
        },
        {
          id: "42_26",
          t: 503,
          l: 247,
          w: 234,
          rotate: 0.8,
        },
        {
          id: "42_32",
          t: 656,
          l: 90,
          w: 162,
          rotate: -10.2,
        },
        {
          id: "42_31",
          t: 628,
          l: 244,
          w: 256,
          rotate: -10.2,
        },
        {
          id: "42_30",
          t: 578,
          l: 495,
          w: 135,
          rotate: -9.2,
        },
        {
          id: "42_54",
          t: 78,
          l: 666,
          w: 102,
          rotate: 88.8,
          road_type: "parkingLot",
          prev: ["42_6"],
        },
        {
          id: "42_53",
          t: 183,
          l: 668,
          w: 253,
          rotate: 88.8,
          road_type: "parkingLot",
        },
      ],

      vehicleObj: {},
      vehicleList: [],
      vehicleJson: "",

      prevVehicle: [],

      gapTime: 10,
      vehicleImgW: 50,

      carSetTimer: {},

      nTimes: 0,
    };
  },
  created() {},
  mounted() {
    let carContainer = $(this.$refs.carContainer);

    this.getCarOnRoadNew();

    let gapTime = this.gapTime * 1.5 * 1000;
    setInterval(() => {
      this.getCarOnRoadNew();
    }, gapTime);
  },
  methods: {
    async getCarOnRoadNew() {
      this.nTimes++;
      const url = `${CONFIG.requestNameRoad}/digit/cleaner`;
      const res = await this.$apiUtils.get(url, {
        customerId: this.customerId,
        dtuNum: null,
      });
      console.log(res);
      if (this.nTimes % 2 === 0) {
        res.forEach((item) => {
          if (item.deviceNo == "40910114051") {
            item.roadModelId = "42_13";
          }
        });
      }
      this.prevVehicle = this.vehicleJson ? JSON.parse(this.vehicleJson) : [];

      for (let i in this.carSetTimer) {
        if (this.carSetTimer[i]) {
          clearTimeout(this.carSetTimer[i]);
        }
      }

      if (this.prevVehicle.length > 0) {
        this.vehicleList = res;
        this.vehicleJson = JSON.stringify(res);
        this.$forceUpdate();
        this.$nextTick(() => {
          this.prevVehicle.forEach((item) => {
            if (
              this.$refs["car-" + item.deviceNo] &&
              this.$refs["car-" + item.deviceNo].length > 0
            ) {
              let tmpNode = this.$refs["car-" + item.deviceNo][0];
              let tmpW = this.getRoadW(item.roadModelId) - this.vehicleImgW;
              $(tmpNode).css("left", parseFloat(item.distanceRateFromSP * tmpW) + "px");
            }
          });

          let newVehicleObj = {};

          if (this.vehicleList.length > 0) {
            this.vehicleList.forEach((element) => {
              let deviceNo = element.deviceNo;
              newVehicleObj[deviceNo] = element;
            });

            console.log("newVehicleObj", newVehicleObj);
            console.log("vehicleObj", this.vehicleObj);
            for (let i in newVehicleObj) {
              if (
                newVehicleObj[i] &&
                this.vehicleObj[i] &&
                newVehicleObj[i]["roadModelId"] === this.vehicleObj[i]["roadModelId"]
              ) {
                if (
                  newVehicleObj[i]["distanceRateFromSP"] !=
                  this.vehicleObj[i]["distanceRateFromSP"]
                ) {
                  let tmpW =
                    this.getRoadW(newVehicleObj[i]["roadModelId"]) - this.vehicleImgW;
                  //console.log(this.$refs["car-" + i]);
                  if (this.$refs["car-" + i] && this.$refs["car-" + i].length > 0) {
                    let tmpNode = this.$refs["car-" + i][0];
                    let curPos =
                      parseFloat(this.vehicleObj[i]["distanceRateFromSP"]) * tmpW;
                    let targetPos =
                      parseFloat(newVehicleObj[i]["distanceRateFromSP"]) * tmpW;
                    console.log($(tmpNode).get(0), curPos, targetPos);
                    this.vehiclePlay(
                      $(tmpNode),
                      i,
                      curPos,
                      targetPos,
                      this.gapTime * 500
                    );
                  }
                } else {
                  let tmpW =
                    this.getRoadW(newVehicleObj[i]["roadModelId"]) - this.vehicleImgW;
                  //console.log("位置未变更", newVehicleObj[i]["roadModelId"], tmpW);
                }
              } else if (
                newVehicleObj[i] &&
                this.vehicleObj[i] &&
                newVehicleObj[i]["roadModelId"] != this.vehicleObj[i]["roadModelId"]
              ) {
                console.log(
                  "道路变更",
                  $(this.$refs["road-" + newVehicleObj[i]["roadModelId"]]).get(0),
                  $(this.$refs["road-" + this.vehicleObj[i]["roadModelId"]]).get(0)
                );
                let curPos =
                  parseFloat(this.vehicleObj[i]["distanceRateFromSP"]) *
                  (this.getRoadW(this.vehicleObj[i]["roadModelId"]) - this.vehicleImgW);
                let targetPos =
                  parseFloat(newVehicleObj[i]["distanceRateFromSP"]) *
                  (this.getRoadW(newVehicleObj["roadModelId"]) - this.vehicleImgW);
                this.vehiclePlayRoadChange(
                  this.vehicleObj[i]["roadModelId"],
                  newVehicleObj[i]["roadModelId"],
                  curPos,
                  targetPos,
                  this.gapTime * 1000
                );
              }
            }
            this.vehicleObj = newVehicleObj;
          } else {
          }
        });
      } else {
        let newVehicleObj = {};
        this.vehicleJson = JSON.stringify(res);
        this.prevVehicle = JSON.parse(this.vehicleJson);

        this.$forceUpdate();
        this.$nextTick(() => {
          this.prevVehicle.forEach((item) => {
            if (
              this.$refs["car-" + item.deviceNo] &&
              this.$refs["car-" + item.deviceNo].length > 0
            ) {
              let tmpNode = this.$refs["car-" + item.deviceNo][0];
              let tmpW = this.getRoadW(item.roadModelId) - this.vehicleImgW;
              $(tmpNode).css("left", parseFloat(item.distanceRateFromSP * tmpW) + "px");
            }
          });
        });

        if (this.vehicleList.length > 0) {
          this.vehicleList.forEach((element) => {
            let deviceNo = element.deviceNo;
            newVehicleObj[deviceNo] = element;
          });
        }
        this.vehicleObj = newVehicleObj;
      }
    },
    vehiclePlayRoadChange(prevRoad, curRoad, prevPos, curPos, time) {
      this.roadList.forEach((item) => {
        if (item.id == prevRoad) {
        }
      });
    },
    vehiclePlay(JqNode, deviceNo, curPos, targetPos, time, idx) {
      if (targetPos != curPos) {
        let n = idx ? idx : 0;
        let deltaPos = curPos + parseFloat(((targetPos - curPos) * n) / (time / 50));
        JqNode.css("left", deltaPos + "px");
        n++;
        if (n < parseInt(time / 50)) {
          if (this.carSetTimer[deviceNo]) {
            clearTimeout(this.carSetTimer[deviceNo]);
          }
          this.carSetTimer[deviceNo] = setTimeout(() => {
            this.vehiclePlay(JqNode, deviceNo, curPos, targetPos, time, n);
          }, 50);
        }
        {
          JqNode.css("left", targetPos + "px");
        }
      }
    },
    getRoadW(roadModelId) {
      let wResult = 0;
      /*try {
        this.roadList.forEach((item) => {
          if (item.id == roadModelId) {
            wResult = item.w;
            throw Error("获取宽度");
          }
        });
      } catch (err) {
        console.log(err);
      }*/
      this.roadList.forEach((item) => {
        if (item.id == roadModelId) {
          wResult = item.w;
        }
      });
      return wResult;
    },
  },
};
</script>

<style scoped lang="scss">
.car-container {
  position: absolute;
  top: 150px;
  left: 1520px;
  width: 740px;
  height: 900px;
  border: 2px solid red;
  z-index: 99;
  pointer-events: all;
}

.road-tag {
  position: absolute;
  transform-origin: top left;
  height: 10px;
  background: red;
}

.car-tag {
  @include bg-box(40px, 20px, "car.png");
  position: absolute;
}
</style>
